import { assignSafe } from '@summit/core';
export class BannerNotice {
  buttonText?: string;
  onClick?: () => void;
  routerLink?: string | string[];
  queryParams?: { [key: string]: string };
  flags?: string[];
  description?: string;
  icon?: string;
  bannerClass?: string;

  constructor(jsonData?: Partial<BannerNotice>) {
    if (jsonData) {
      assignSafe(this, jsonData);
    }
  }
}
